import React from 'react'

import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Col, Row, Divider, Tabs } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { CodigosTransaccionesConstant } from 'constants/index'

import * as UsuarioCrud from 'services/usuario.service'

import * as FormGroups from './formGroups'
import * as InnerTabs from './tabs'

const validationSchema = Yup.object().shape({
  username: Yup.string().required(),
  contrasena: Yup.string().required(),
  companias: Yup.array().required()
})

const validationSchemaEdicion = Yup.object().shape({
  username: Yup.string().required(),
  companias: Yup.array().required()
})

const NuevoMainForm = ({ editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()

  const submitHandler = React.useCallback(
    async data => {
          console.log("📦 Payload que se va a enviar al backend:", data)

      const funcionCrud = editarData._id ? () => UsuarioCrud.actualizarxId(editarData._id, data) : () => UsuarioCrud.nuevo(data)
      await funcionCrud()
        .then(() => {
          history.push(`/${CodigosTransaccionesConstant.USUARIOS_LISTA}`)
          __zariContext.snack('success', editarData._id ? 'El registro se ha actulizado' : 'El registro se ha creado.')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext, history, editarData._id]
  )

  const formInitialValues = React.useMemo(() => {
    if (editarData._id) {
      return {
        _idsRoles: editarData._idsRoles || [],
        apellidos: editarData.apellidos || '',
        companias: editarData.companias || [],
        _idSocio: editarData._idSocio || '',
        numeroDocumentoSocio: editarData.numeroDocumentoSocio || '',
        razonSocialSocio: editarData.razonSocialSocio || '',
        nombres: editarData.nombres || '',
        username: editarData.username || '',
        correo: editarData.correo || ''
      }
    }

    return {
      _idsRoles: [],
      username: '',
      _idSocio: '',
      numeroDocumentoSocio: '',
      razonSocialSocio: '',
      correo: '',
      nombres: '',
      apellidos: '',
      contrasena: '',
      companias: []
    }
  }, [editarData])

  return (
    <Row>
      <Col md={12}>
        <Formik
          initialValues={formInitialValues}
          onSubmit={submitHandler}
          validationSchema={editarData._id ? validationSchemaEdicion : validationSchema}
        >
          {({ errors, handleSubmit, isSubmitting, touched, values }) => (
            <Form>
              <Divider title='Datos Básicos' />
              <Row>
                <Col md={6}>
                  <FormGroups.UsernameFormGroup iError={errors.username} iTouched={touched.username} fIsSubmitting={isSubmitting} />
                  {!editarData._id && (
                    <FormGroups.ContrasenaFormGroup iError={errors.contrasena} iTouched={touched.contrasena} fIsSubmitting={isSubmitting} />
                  )}
                </Col>
                <Col md={6}>
                  <FormGroups.NombresFormGroup />
                  <FormGroups.ApellidosFormGroup />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroups.CorreoFormGroup />
                </Col>
              </Row>
              <Divider title='Personalización' />
              <Tabs defaultActiveKey='1' id='personalizacion-usuarios-tab'>
                <Tabs.Tab eventKey='1' title='Companias'>
                  <InnerTabs.AccesosSeriesTab companiasSeleccionadas={values.companias} />
                </Tabs.Tab>
                <Tabs.Tab eventKey='2' title='Roles'>
                  <InnerTabs.RolesTab rolesSeleccionados={values._idsRoles} />
                </Tabs.Tab>
              </Tabs>
              <Row className='mt-4'>
                <Col md={12} className='text-right'>
                  <Button onClick={handleSubmit}>{editarData._id ? 'Actualizar' : 'Crear'}</Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Col>
    </Row>
  )
}

export default NuevoMainForm
